import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import Login from './Dashbord/Login';
import Register from './Dashbord/Register';

import Dashbord from './Dashbord/Dashbord';
import MyProduct from './components/MyProduct';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gloria" element={<MyProduct />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashbord" element={<Dashbord />} />
      </Routes>
    </Router>
  );
}

export default App;
